import * as React from "react";
import { Tooltip } from "./Tooltip";
import { Util } from "../util";

export const DateWithTooltip = ({ date }: { date: Date }): JSX.Element => {
  return (
    <Tooltip
      element={<span>{date.toDateString()}</span>}
      tooltip={Util.FormatDate(date)}
    />
  );
};
